export function getStoredNumber(key, fallback = 0) {
  try {
    const value = window.localStorage.getItem(key);
    const number = Number(value);
    return Number.isFinite(number) ? number : fallback;
  } catch (_error) {
    return fallback;
  }
}

export function setStoredNumber(key, value) {
  try {
    window.localStorage.setItem(key, String(value));
  } catch (_error) {
    // Storage can be unavailable in strict private modes; the game still works.
  }
}

export function isCooldownActive(key) {
  return getStoredNumber(key, 0) > Date.now();
}

export function setCooldown(key, ms) {
  setStoredNumber(key, Date.now() + ms);
}

export function updateBestStreak(streak) {
  const previous = getStoredNumber("wq_best_streak", 0);
  if (streak > previous) setStoredNumber("wq_best_streak", streak);
  return Math.max(previous, streak);
}
